import React, { useState, lazy } from 'react';
import { ArrowRight, Star, ShieldCheck, Flame, Loader2 } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const CHECKOUT_URL = 'https://the-basketball-coach-s-bible.impultienda.ar/checkout';
export function PricingSection() {
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    // Immediate visual feedback so the user knows the click registered,
    // even though the new tab takes a moment to load the external page.
    setLoading(true);
    // Reset after a short delay in case the user comes back to this tab.
    setTimeout(() => setLoading(false), 6000);
  };
  return <section id="offer" className="bg-gradient-to-b from-bb-charcoal to-bb-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-152">
      <div className="absolute inset-0 court-lines opacity-[0.08] pointer-events-none" data-id="element-153"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-bb-orange/15 rounded-full blur-3xl pointer-events-none" data-id="element-154"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-155">
        <div className="bg-bb-orange/20 backdrop-blur-sm border border-bb-orange/40 text-bb-orange-light font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-156">
          Special Launch Offer — Complete 6-in-1 Bundle
        </div>
        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-white leading-tight mb-4 tracking-tight" data-id="element-157">
          Access the system now and transform your team{' '}
          <span className="text-bb-orange" data-id="element-158">starting tonight</span>
        </h2>

        <div className="mb-8 max-w-md mx-auto mt-10" data-id="element-159">
          <img src="https://cdn.magicpatterns.com/uploads/dWteTQevNEHvKbLzQXkEmc/heylloyd-image-1780160765114.webp" alt="The Basketball Coach's Bible 6-in-1 Pack" className="w-full rounded-2xl shadow-2xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-160" />
        </div>

        <div id="pricing-card" className="bg-white rounded-3xl p-6 sm:p-8 shadow-2xl max-w-md mx-auto scroll-mt-8 border-t-4 border-bb-orange" data-id="element-161">
          <p className="text-bb-slate text-sm mb-1" data-id="element-162">
            Regular Price: <span className="line-through" data-id="element-163">$97</span>
          </p>

          <div className="inline-flex items-center gap-2 bg-bb-orange text-white text-xs font-bold px-3 py-1.5 rounded-full my-3 uppercase tracking-wide shadow-md" data-id="element-164">
            <Flame className="w-4 h-4" data-id="element-165" /> 70% OFF — Limited Time
          </div>

          <p className="text-bb-slate text-sm mb-1" data-id="element-166">Discounted Price:</p>
          <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-167">
            <p className="font-display font-bold text-6xl sm:text-7xl text-bb-orange leading-none" data-id="element-168">
              $27
            </p>
            <span className="font-display font-bold text-2xl sm:text-3xl text-bb-orange leading-none" data-id="element-169">
              USD
            </span>
          </div>
          <p className="text-bb-slate text-xs mb-4 italic" data-id="element-170">
            You'll be charged in your local currency at checkout.
          </p>

          <p className="text-bb-orange-dark font-semibold text-sm mb-5 flex items-center justify-center gap-1" data-id="element-171">
            🔥 Very few copies remaining at this price
          </p>

          <div className="mb-6" data-id="element-172">
            <CountdownTimer data-id="element-173" />
          </div>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener" onClick={handleClick} aria-busy={loading} className={`group w-full bg-bb-orange hover:bg-bb-orange-dark text-white font-bold text-base sm:text-lg uppercase tracking-wide py-4 px-6 rounded-full shadow-[0_10px_30px_rgba(234,88,12,0.45)] hover:shadow-[0_15px_40px_rgba(234,88,12,0.6)] hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3 ${loading ? 'opacity-90 pointer-events-none' : ''}`} data-id="element-174">
            {loading ? <>
                <Loader2 className="w-5 h-5 animate-spin" data-id="element-175" />
                <span data-id="element-176">Opening Checkout…</span>
              </> : <>
                <span data-id="element-177">🏀 I Want My 6-in-1 Pack ($27)</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-178" />
              </>}
          </a>

          <div className="mt-5 flex flex-col items-center gap-2" data-id="element-179">
            <div className="flex items-center gap-2" data-id="element-180">
              <div className="flex text-bb-orange" data-id="element-181">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-182" />)}
              </div>
              <span className="text-bb-slate text-sm font-medium" data-id="element-183">
                4.9/5 — Verified Reviews
              </span>
            </div>
            <div className="flex items-center gap-2 text-bb-slate text-sm" data-id="element-184">
              <ShieldCheck className="w-4 h-4 text-bb-orange" data-id="element-185" />
              <span data-id="element-186">30-Day Money-Back Guarantee — ZERO Risk</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}